<template>
  <div class="headBox clearfix" :style="{background: 'url(' + allImageMap.gameMain_03_04 + ')'}">
    <!--headLeft-->
    <div class="headLeft" :style="{background: 'url(' + allImageMap.gameMainhead + ') no-repeat'}"></div>
    <!--headRight-->
    <div class="headRight" :style="{background: 'url(' + allImageMap.gameMain03 + ')'}">
      <div class="lastBg clearfix" :style="{background: 'url(' + allImageMap.gameMain01 + ')'}"></div>
      <div class="firstBg clearfix" :style="{background: 'url(' + allImageMap.gameMain02 + ')'}"></div>

      <!--用户姓名-->
      <div  v-if="competeType == '0'||competeType == '1'||competeType == '3'||competeType == '4'" class="fullName clearfix" :style="{background: 'url(' + allImageMap.gameMain_03_04 + ')'}">
        <div class="fullName_left" :style="{background: 'url(' + allImageMap.gameMain05 + ')'}"></div>
        <div class="fullName_right" :style="{background: 'url(' + allImageMap.gameMain04 + ')'}"></div>
        <span>{{fullName}}</span>
      </div>
      <!-- 返回主页按钮 -->
      <p
        class="headRight-btnr clearfix"
        ref="headRight_btnr"
        :style="{background: 'url(' + allImageMap.gameMain_0901 + ') no-repeat'}"
        @click="goHomePage"
        @mouseover="seeStyle('3')"
        @mouseleave="leaveStyle('3')"
      ></p>
      <!-- 显示代码索引 按钮 showCodeIndexDialog -->
      <div
        ref="headRight_btnm"
        class="headRight_btnm clearfix"
        @click="clickChangeLanMenu1"
        @mouseover="seeStyle('2')"
        @mouseleave="leaveStyle('2')" >
        <div
          class="headRight_btnm_bg"
          :style="{background: 'url(' + allImageMap.gameMain_0601 + ') no-repeat'}"
        ></div>
        <!-- <div
          class="headRight_btnm_img"
          :style="{background: 'url(' + allImageMap.codeIndexButton + ') no-repeat'}"
        ></div>-->
        <div class="headRight_btnl_txt"  :dir="dirLang">{{langText}}</div>
      </div>
      <!-- 菜单 -->
      <div ref="headRight_btnl" class="headRight_btnl clearfix" @click="clickChangeLanMenu" @mouseover="seeStyle('1')" @mouseleave="leaveStyle('1')" >
        <div
          class="headRight_btnl_bg"
          :style="{background: 'url(' + allImageMap.gameMain_0601 + ') no-repeat'}"
        ></div>
        <div
          :style="{background: 'url(' + allImageMap.menu + ') 10px center  no-repeat',paddingLeft:'10px'}"
          class="headRight_btnl_txt"
          :dir="dirLang"
        >{{$t('message.menu')}}</div>
      </div>
      <!-- 切换语言 下拉菜单 -->
      <ul v-show="langMenu">
        <!--<li @click="changeLang('he')" v-show="curLan != 'he'">עברית</li>
        <li @click="changeLang('ar')" v-show="checkLangs != 'ar'">العربية</li>-->
        <li @click="changeLang('en')" v-show="checkLangs != 'en'">English</li>
        <li @click="changeLang('zh')" v-show="checkLangs != 'zh'">中文</li>
        <li @click="changeLang('he')" v-show="checkLangs != 'he'">עברית</li>
        <!--<li @click="changeLang('sp')" v-show="curLan != 'sp'">Español</li>
        <li @click="changeLang('fr')" v-show="curLan != 'fr'">Français</li>-->
      </ul>
      <!--显示课程名字-->
      <div
        class="level"
        v-if="competeType == '0'||competeType == '3'||competeType == '4'||competeType == '5'"
        :style="{background: 'url(' + allImageMap.level + ')'}"
      >{{courseTitleTxt}}</div>
      <!--显示倒计时-->
      <div
        v-if="competeType == 1 || competeType == 2|| competeType == 4"
        class="level"
        :style="{background: 'url(' + allImageMap.level + ')'}">
        {{$t('message.time_remain')}}<span v-loading="loadingTimeShow" element-loading-spinner="el-icon-loading" element-loading-background="rgba(33,86,131, 1)">{{timeText}}</span> </div>
      <!--显示初级组-->
      <div
        v-if="edition==1&&(competeType == '0'||competeType == '1')"
        class="level"
        :style="{background: 'url(' + allImageMap.level + ')'}"
      >{{$t('message.level01')}}</div>
      <!--显示高级组-->
      <div
        v-if="edition==2&&(competeType == '0'||competeType == '1')"
        class="level"
        :style="{background: 'url(' + allImageMap.level + ')'}"
      >{{$t('message.level03')}}</div>
      <!--显示中级组-->
      <div
        v-if="edition==3&&(competeType == '0'||competeType == '1')"
        class="level"
        :style="{background: 'url(' + allImageMap.level + ')'}"
      >{{$t('message.level02')}}</div>
      <!--显示入门组-->
      <div
        v-if="edition==0&&(competeType == '0'||competeType == '1')"
        class="level"
        :style="{background: 'url(' + allImageMap.level + ')'}"
      >{{$t('message.level00')}}</div>
    </div>
    <!-- 标题文字 -->
    <div class="headText" :dir="dirLang">{{headText}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../store";
import Axios from "axios";
import AdventureManager from "../../manager/AdventureManager";
import OperateDom from "../../manager/OperateDom";
import HttpService from "../../service/HttpService"; //引入axios配置
import Cookies from "js-cookie";
import Const from "../../const/Const";
export default {
  data() {
    return {
      langMenu: false,
      langText: "",
      lanMap: {
        zh: "中文",
        en: "English",
        he: "עברית",
        // sp: "Español",
        // fr: "Français",
        // he:'עברית',
        // ar:'العربية',
      },
      num: 0,
      highLever: "",
      txt: "",
      msg: "",
      timer: null,
    };
  },
  mounted() {
    let lan = AdventureManager.getQueryString("zhOren");
    this.highLever = AdventureManager.getQueryStringLevel("highLevel");
    store.state.checkLangs = lan;
    this.$i18n.locale = lan;
    this.langText = this.lanMap[lan];
    // 监听事件
    this.$nextTick(() => {
      window.addEventListener("click", () => {
        this._wantCloseLanMenu = true;
      });
    });
    setTimeout(() => {
      store.state.loadingTimeShow = false;
    }, 2000);
  },
  components: {},
  methods: {
    update(dt) {
      if (this._wantCloseLanMenu && !this._wantHandleLanMenu) {
        this.langMenu = false;
      } else if (this._wantHandleLanMenu) {
        this.langMenu = !this.langMenu;
      }
      this._wantCloseLanMenu = false;
      this._wantHandleLanMenu = false;
    },
    // 显示代码索引弹窗
    showCodeIndexDialog() {
      AdventureManager.toFront_showCodeIndexDialog();
    },
    // 回到主页
    goHomePage() {
      if(store.state.competeType==Const.COMPETE_TYPE_TOUR){
        store.state.tourNotCompelete = true;
        store.state.customeType = 'TourNotComplete';
        return;
      }
      store.state.skipStyleShow = false;
      store.state.skipShow = false;
      OperateDom.getStyle(
        this.$refs.headRight_btnr,
        store.state.allImageMap.shadow_back
      );
      setTimeout(() => {
        OperateDom.getStyle(
          this.$refs.headRight_btnr,
          store.state.allImageMap.gameMain_0901
        );
      }, 1000);
      store.state.toBack = true;
      AdventureManager.sendToGame("exitGame");
    },
    clickChangeLanMenu1() {
      this._wantHandleLanMenu = true;
    },
    // 点击切换语言菜单按钮
    clickChangeLanMenu() {
      OperateDom.getStyle(
        $(".headRight_btnl_bg")[0],
        store.state.allImageMap.shadow_head
      );
      setTimeout(() => {
        OperateDom.getStyle(
          $(".headRight_btnl_bg")[0],
          store.state.allImageMap.gameMain_0601
        );
      }, 1000);
      if (store.state.menuFlag) return;
      store.state.menuFlag = true;
      store.state.knowledgeArr = window.bridge.getCourseList(0);
      store.state.CommandList = window.bridge.getCommandList(0);
      store.state.StoryIntroList = window.bridge.getStoryIntroList(0);
      store.state.highCheckShow = false;
      // 获取用户信息
      AdventureManager.getMenuInfo();
    },
    // 切换语言
    changeLang(lan) {
      store.state.checkLangs = lan;
      store.state.checkLangDialogShow = true;
      sessionStorage.setItem("Lanauge",lan);
	  localStorage.setItem("zhOren",lan);
      Cookies.set("zhOren",lan)
    },
    seeStyle(index) {
      let el = null;
      if (index == "1") el = this.$refs.headRight_btnl;
      if (index == "2") el = this.$refs.headRight_btnm;
      if (index == "3") el = this.$refs.headRight_btnr;
      el.style.marginTop = "3px";
      OperateDom.setTransition(el, "none", "1", "scale(1.1)");
    },
    leaveStyle(index) {
      let el = null;
      if (index == "1") el = this.$refs.headRight_btnl;
      if (index == "2") el = this.$refs.headRight_btnm;
      if (index == "3") el = this.$refs.headRight_btnr;
      el.style.marginTop = "0";
      OperateDom.setTransition(el, "none", "1", "scale(1)");
    },
    courseFilter(status) {
      return this.$t("message.course_"+status);
    },
  },
  computed: {
    ...mapGetters([
      "headText",
      "allImageMap",
      "checkpointShow",
      "toBack",
      "dirLang",
      "level",
      "fullName",
      "userLastName",
      "userFirstName",
      "skipStyleShow",
      "Workspace",
      "chooseMode",
      "lang",
      "checkLangDialogShow",
      "checkLangs",
      "gameId",
      "times",
      "competeType",
      'edition',
      "timeText",
      "timeoverShow",
      "loadingTimeShow",
      "checkLangShow",
      "courseTitleTxt",
    ]),
    fullName() {
      if (this.$i18n.locale == "zh") {
        return (store.state.userLastName == undefined ? '' : store.state.userLastName) + store.state.userFirstName;
      } else {
        return store.state.userFirstName + " " + (store.state.userLastName == undefined ? '' : store.state.userLastName);
      }
    },
  },
};
</script>

<style scoped>
.headBox {
  height: 66px;
  z-index: 2;
  background-repeat: repeat-x;
  position: relative;
}
.headLeft {
  position: absolute;
  left: 0;
  top: 0;
  height: 66px;
  width: 81px;
}
.headRight {
  position: absolute;
  right: 0;
  height: 66px;
  min-width: 444px;
  background-repeat: repeat-x;
}
.lastBg {
  width: 26px;
  height: 66px;
  float: right;
}
.firstBg {
  width: 37px;
  height: 66px;
  float: left;
}
.fullName {
  min-width: 100px;
  height: 66px;
  float: left;
  border-radius: 20px;
  font-size: 18px;
  color: #fff;
  line-height: 66px;
  margin: 0 5px;
}
.fullName_right {
  width: 28px;
  height: 66px;
  float: right;
}
.fullName_left {
  width: 12px;
  height: 66px;
  float: left;
}
.fullName span {
  text-align: center;
  padding-left: 10px;
}
.headRight-btnr {
  width: 65px;
  height: 56px;
  float: right;
  cursor: pointer;
  margin-left: 40px;
}
.level {
  width: 149px;
  height: 49px;
  float: right;
  text-align: center;
  line-height: 49px;
  color: #fff;
  font-size: 18px;
  margin-top: 7px;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.headRight_btnm {
  /* 代码索引按钮 */

  width: calc(0.4 * 159px);
  height: 56px;
  float: right;
  cursor: pointer;
  margin-left: 10px;
}
.headRight_btnm_bg {
  /* 选择语言按钮 背景图 */
  position: absolute;
  width: 159px;
  height: 56px;
  transform: scaleX(0.6);
  transform-origin: 0% 50%;
}
.headRight_btnm_img {
  /* 选择语言按钮 前景图 */
  position: absolute;
  width: 34px;
  height: 35px;
  transform: scale(1);
  left: 15px;
  top: 8px;
}
.headRight_btnl {
  /* 选择语言按钮 */
  width: calc(0.6 * 159px);
  height: 56px;
  float: right;
  cursor: pointer;
}
.headRight_btnl_bg {
  /* 选择语言按钮 背景图 */
  position: absolute;
  width: 159px;
  height: 56px;
  transform: scaleX(0.6);
  transform-origin: 0% 50%;
}
.headRight_btnl_txt {
  /* 选择语言按钮 文字 */
  position: absolute;
  width: calc(0.6 * 159px);
  height: 56px;
  line-height: 56px;
  text-align: center;
  color: #ffffff;
  font-size: 20px;
  z-index: 1;
}
.headText {
  position: absolute;
  height: 100%;
  left: 81px;
  right: 648px;
  text-align: center;
  line-height: 65px;
  font-size: 24px;
  color: #fffeff;
  overflow: hidden;
}
.headRight > ul {
  position: absolute;
  right: 99px;
  top: 55px;
  z-index: 11;
  border-radius: 0 0 6px 6px;
}
.headRight > ul > li {
  /* 选择语言菜单 下拉按钮 */
  box-sizing: border-box;
  width: calc(0.6 * 159px);
  height: 56px;
  color: #ffffff;
  position: relative;
  cursor: pointer;
  background-color: #0e81b6;
  border-radius: 6px;
  text-align: center;
  font-size: 20px;
  line-height: 56px;
}
.headRight > ul > li:hover {
  /* 选择语言菜单 下拉按钮 鼠标放上面时*/
  background-color: #e9ae2c;
}

@media (max-height: 420px) and (orientation: landscape) {
	.headBox {
		transform: scaleY(0.7);
	    transform-origin: 0% 0%;
		overflow: hidden;
	}
	/*.headBox,
	.headLeft,
	.headRight,
	.firstBg,
	.lastBg,
	.fullName,
	.fullName_left,
	.fullName_right,
	.level,
	.headRight_btnl,
	.headRight_btnl_bg,
	.headRight_btnl_txt,
	.headRight_btnm,
	.headRight_btnm_bg,
	.headRight-btnr
	{
		height: 40px;
	}
	.headText, .headRight_btnl_txt {
		line-height: 40px;
	}
	.fullName, .level {
		line-height: 52px;
	}
	.headRight_btnl_bg {
		background-size: cover !important;
	}
	.level {
		height: 33px;
		line-height: 39px;
	}*/
	/*.fullName {
		transform: scaleX(.6);
		transform-origin: 0;
	}
	.level {
		transform-origin: 0 0;
		transform: scaleX(.7);
	}*/
}
</style>



// WEBPACK FOOTER //
// src/components/onlineClass/head.vue